// 试做客户列表
<template>
  <div class="threeLevelMain">
    <!-- 头部查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row" v-show="!isFoldQuery">
        <div class="scan_box">
          <span class="sp_scan">公司名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.corporate_name"
            placeholder="全部"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">品牌名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.brand_name"
            placeholder="请输入品牌"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">合作性质：</span>
          <el-select
            clearable
            v-model="getTabData.properties"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in khlxOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="block scan_box">
          <span class="sp_scan">签订时间：</span>
          <el-date-picker
            v-model="valueDate"
            :editable="false"
            type="monthrange"
            class="date_range"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchBtn('contact')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="block scan_box">
          <span class="sp_scan">到期时间：</span>
          <el-date-picker
            v-model="dqsjDate"
            :editable="false"
            class="date_range"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchBtn('due')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="scan_box">
          <span class="sp_scan">运营分部：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.group"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operationDepartmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">店长：</span>
          <!-- <el-input class="ip_scan" v-model="getTabData.assign_id" placeholder="请输入店长姓名" size="mini" style="width:200px;"></el-input> -->
          <el-select
            clearable
            v-model="getTabData.assign_id"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">组长：</span>
          <el-select
            clearable
            v-model="getTabData.assign_name_leader"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">类目：</span>
          <el-select
            clearable
            v-model="getTabData.category"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">销售：</span>
          <el-select
            clearable
            v-model="getTabData.sale_id"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">试做状态：</span>
          <el-select
            clearable
            v-model="getTabData.is_contract"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="进行中" value="5"></el-option>
            <el-option label="试做结束" value="4"></el-option>
          </el-select>
        </div>
        <!-- 购买人员用于查看所有客户信息（只读） -->
        <div class="scan_box" v-if="userId == '173'">
          <span class="sp_scan">查看状态：</span>
          <el-select
            v-model="getTabData.is_Purchase"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="默认" value=""></el-option>
            <el-option label="所有客户信息（只读）" value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn_area_out" v-show="!isFoldQuery">
        <!-- <el-button 
            size="mini" 
            @click="searchBtn">查询</el-button> -->

        <el-button
          size="mini"
          @click="resetSearch"
          type="primary"
          icon="el-icon-refresh"
          >重置筛选</el-button
        >

        <el-button
          size="mini"
          @click="exportClick"
          v-if="exportQX"
          icon="el-icon-download"
          >导出数据</el-button
        >
      </div>
      <!-- 折叠区域 -->
      <div class="fold_btn">
        <!-- 展开 -->
        <div
          class="f_open_area little_hands"
          @click="isFoldQuery = !isFoldQuery"
          v-show="!isFoldQuery"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            class="btn_icon_s"
          ></el-button>
          <p class="fold_content">收起</p>
        </div>
        <!-- 折叠 -->
        <div class="f_fold_area" v-show="isFoldQuery">
          <h3>筛选区域</h3>
          <div
            class="f_f_content little_hands"
            @click="isFoldQuery = !isFoldQuery"
          >
            <p class="fold_content">展开</p>
            <el-button
              type="text"
              icon="el-icon-arrow-down"
              class="btn_icon_s"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
      :recalculateTag="isFoldQuery"
    >
      <el-table-column
        slot="corporate_name"
        align="center"
        label="公司名称"
        width="120"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.corporate_name }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        slot="brand_name"
        align="center"
        label="品牌名称"
        width="120"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.brand_name }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column slot="state" align="center" label="状态" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.is_contract == 3" class="fontColor_success">
            进行中
          </div>
          <div v-else-if="scope.row.is_contract == 4" class="fontColor_danger">
            试做结束
          </div>
        </template>
      </el-table-column>
      <!-- 最近沟通时间 -->
      <el-table-column
        slot="touch_time"
        width="180"
        align="center"
        label="最近沟通时间"
        sortable
        prop="touch_time"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.touch_time == "" ? "未沟通" : scope.row.touch_time }}
          </div>
        </template>
      </el-table-column>

      <!-- 方案金额 -->
      <el-table-column
        slot="contract_amount"
        width="100"
        align="center"
        label="方案金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.contract_amount }}</div>
        </template>
      </el-table-column>

      <!-- 试做金额 -->
      <el-table-column
        slot="down_payment"
        width="100"
        align="center"
        label="试做金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.down_payment }}</div>
        </template>
      </el-table-column>

      <!-- 波罗蜜 -->
      <el-table-column
        slot="boluomi"
        width="100"
        align="center"
        label="波罗蜜"
        v-if="jurisdiction"
      >
        <template slot-scope="scope">
          {{ scope.row.boluomi }}
          <el-popover
            placement="top-start"
            width="200"
            trigger="manual"
            v-model="scope.row.boluomiVisible"
          >
            <div>
              <el-input
                style="margin-bottom: 10px"
                v-model="scope.row.boluomi"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="scope.row.boluomiVisible = false"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="remarkEditConfirm(scope.row, scope.$index)"
                >确定</el-button
              >
            </div>
            <i
              class="el-icon-edit"
              slot="reference"
              @click="remarkEditClick(scope.$index)"
              style="cursor: pointer"
            ></i>
          </el-popover>
        </template>
      </el-table-column>

      <!-- 试做反馈 -->
      <el-table-column
        slot="feedback_info"
        align="center"
        label="试做反馈"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.feedback_info }}
            <el-popover placement="top" width="300" trigger="click">
              <div>
                <el-input
                  type="textarea"
                  style="margin-bottom: 10px"
                  v-model="scope.row.feedback_info"
                  size="mini"
                  placeholder="请输入内容"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                >
                </el-input>
              </div>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="primary"
                  size="mini"
                  @click="subFeedBack(scope.row)"
                  >确定</el-button
                >
              </div>

              <i
                class="el-icon-edit"
                slot="reference"
                style="cursor: pointer"
              ></i>
            </el-popover>
          </div>
        </template>
      </el-table-column>

      <!-- 店长 -->
      <el-table-column
        slot="assign_name"
        width="60"
        align="center"
        label="店长"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.assign_name }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="group_name" width="60" align="center" label="组长">
        <template slot-scope="scope">
          <div>{{ scope.row.assign_name_leader }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="sale_id" align="center" label="销售" width="60">
        <template slot-scope="scope">
          <div>{{ scope.row.sale_name }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="viewable_person"
        width="200"
        align="center"
        label="相关销售"
      >
        <template slot-scope="scope">
          <!-- 最高权限或销售主管可设置 -->
          <div v-if="jurisdiction || $tools.sessionGetStore('post') == 7">
            <el-select
              v-model="scope.row.viewable_person"
              multiple
              collapse-tags
              placeholder="设置相关销售"
              @change="viewableHandle(scope.row)"
            >
              <el-option
                v-for="item in salePersonOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div v-else>
            {{ scope.row.viewable_name.join("、") }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="is_contract"
        align="center"
        label="是否断约"
        width="50"
      >
        <template slot-scope="scope">
          <div
            :class="
              scope.row.is_contract == '1'
                ? 'fontColor_danger'
                : 'fontColor_theme'
            "
          >
            {{ scope.row.is_contract == "1" ? "是" : "否" }}
          </div>
        </template>
      </el-table-column>

      <!-- 客户姓名 -->
      <!-- <el-table-column
            slot="customer_name"
            width="120"
            align="center"
            label="客户姓名"
        >
            <template slot-scope="scope">
                <div>{{scope.row.customer_name}}</div>
            </template>
        </el-table-column> -->
      <el-table-column
        slot="zhipai"
        align="center"
        label="指派操作"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="warning"
            plain
            size="mini"
            @click="openAssignDia(scope.row)"
            >修改指派</el-button
          >
        </template>
      </el-table-column>

      <!-- 签约操作 试做客户签约只能通过新建客户申请-->
      <el-table-column
        slot="signUp"
        align="center"
        label="签约操作"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="warning"
            plain
            size="mini"
            @click="openContractDia(scope.row)"
            >签约</el-button
          >
        </template>
      </el-table-column>

      <!-- 添加小记操作 -->
      <el-table-column
        slot="addBtn"
        align="center"
        label="销售沟通小记"
        width="105"
      >
        <template slot-scope="scope">
          <el-link type="success" @click="openDialog(scope.row, true)"
            >新建小记</el-link
          >
        </template>
      </el-table-column>

      <el-table-column
        slot="kill_contract"
        align="center"
        label="断约操作"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <!-- <el-button 
              class="tableBtn_width" 
              type="danger" 
              plain size="mini" 
              @click="openDYDialog(scope.row.id)" 
              >断约</el-button> -->
          <el-button
            class="tableBtn_width"
            type="danger"
            plain
            size="mini"
            @click="shutDownBtn(scope.row)"
            >试做结束</el-button
          >
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 总数量和总金额统计 -->
    <!-- <div class="totalAmount">
        <p>总金额：<span>{{zje == ''? 0 : zje}}.00 元</span></p>
        <p>总数量：<span>{{zsl}}</span></p>
      </div> -->

    <!-- 添加小记对话框 -->
    <el-dialog
      title="新建沟通小记"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="addClose"
    >
      <!-- 表单部分 -->
      <el-form
        :model="touchForm"
        :rules="touchRules"
        ref="touchForm"
        label-width="100px"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="touchForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公司编号" prop="id">
          <el-input v-model="touchForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作人" prop="user_name">
          <el-input v-model="touchForm.user_name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="沟通小记" prop="contact_Records">
          <el-input v-model="touchForm.contact_Records"></el-input>
        </el-form-item>
        <el-form-item label="沟通方式" prop="contact_meth">
          <el-input v-model="touchForm.contact_meth"></el-input>
        </el-form-item>
        <el-form-item label="审核" prop="to_examine">
          <el-input v-model="touchForm.to_examine"></el-input>
        </el-form-item>
        <el-form-item label="投诉" prop="complaint">
          <el-input v-model="touchForm.complaint"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            :rows="2"
            v-model="touchForm.remarks"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹出确认框 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTouchInfo('touchForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 指派客户对话框 -->
    <el-dialog
      title="修改指派"
      :visible.sync="assignVisible"
      width="500px"
      :before-close="assignClose"
    >
      <el-form
        :model="assignForm"
        ref="assignForm"
        label-width="100px"
        :show-message="false"
      >
        <!-- <el-form-item label="客户编号" prop="id">
            <el-input v-model.number="assignForm.id" disabled></el-input>
          </el-form-item> -->
        <el-form-item label="公司名称">
          <el-input
            v-model="assignForm.name"
            class="commit_input_wd"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="店长" prop="assign_id" required>
          <el-select
            v-model="assignForm.assign_id"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组长" required>
          <el-select
            v-model="assignForm.assign_id_leader"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主管" prop="assign_id_supervisor" required>
          <el-select
            v-model="assignForm.assign_id_supervisor"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in operateSuperOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" @click="assignHandle('assignForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 断约客户对话框 -->
    <el-dialog
      title="填写断约原因"
      :visible.sync="dyVisible"
      width="500px"
      :before-close="addClose"
    >
      <el-input
        v-model="dy_reason"
        type="textarea"
        placeholder="请填写断约原因"
        :rows="3"
      ></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dyVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertcontract()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 签约信息对话框 -->
    <el-dialog
      title="签约信息填写"
      :visible.sync="baseInfoVisible"
      width="90%"
      :before-close="assignClose"
    >
      <div>
        <NewCustomer
          isNewAdd="4"
          :fatherGiveYou="contract_form"
          state="12"
          @completeView="subComplete"
        ></NewCustomer>
      </div>
    </el-dialog>

    <!-- 导出对话框 -->
    <div class="dialog_box">
      <listExportXlsx
        :exportDataAll="exportDataAll"
        :exportClickTag="exportClickTag"
        @getApiParams="getApiParamsFunc"
        apiName="customerListExport"
      ></listExportXlsx>
    </div>

    <DetailContract :detailConfig="detailConfig"></DetailContract>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import NewCustomer from "@/components/workOrder/newCustomer.vue";
import moment from "moment";
import options from "@/libs/common.js";
export default {
  components: {
    NewCustomer,
  },
  data() {
    // let cp = utils.sessionGetStore('tryItOutList')
    // cp = cp == null ? 1 : cp
    let testPhone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!utils.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      isFoldQuery: false,
      btnState: false,
      monthPickerOptions: options.monthPickerOptions,
      valueDate: [], //签订日期区间
      dqsjDate: [], //到期时间区间
      cnOption: [
        {
          value: "",
          label: "全部",
        },
      ], //公司名选项

      //表格内容相关
      loading: false, //表格内容加载中
      dataList: [], //表格数据列表
      columnsList: [
        // {
        //   label:'新建沟通小记',
        //   slotName:"addBtn"
        // },
        // {
        //     label:"客户编号",
        //     prop:"customer_id"
        // },
        {
          label: "公司名称",
          slotName: "corporate_name",
        },
        {
          label: "品牌名称",
          slotName: "brand_name",
        },
        {
          label: "状态",
          slotName: "state",
        },
        {
          label: "主要产品",
          prop: "main_products",
          width: 100,
        },
        // {
        //   label:"旗舰店网址",
        //   prop:'shop_url' ,
        //   width: 120
        // },
        {
          label: "方案金额",
          slotName: "contract_amount",
        },
        {
          label: "试做金额",
          slotName: "down_payment",
        },
        {
          label: "波罗蜜",
          slotName: "boluomi",
        },
        {
          label: "试做反馈",
          slotName: "feedback_info",
        },
        {
          label: "反馈时间",
          prop: "feedback_time",
          width: 100,
        },

        {
          label: "对接人",
          prop: "meet_people",
        },
        {
          label: "手机号",
          prop: "phone",
          width: 100,
        },
        {
          label: "处理平台",
          prop: "plt",
        },
        {
          label: "店长",
          slotName: "assign_name",
        },
        {
          label: "组长",
          slotName: "group_name",
        },
        {
          label: "运营主管",
          prop: "assign_name_supervisor",
        },
        {
          label: "销售",
          prop: "sale_name",
        },
        {
          label: "销售主管",
          prop: "leader_name",
        },
        {
          label: "相关销售",
          slotName: "viewable_person",
        },
        // {
        //   label:"是否断约",
        //   slotName:'is_contract'
        // },
        {
          label: "最近沟通时间",
          slotName: "touch_time",
        },
        // {
        //   label:"试做内容",
        //   prop:"try_text",
        //   width: 200
        // },
        // {
        //   label:"试做需求",
        //   prop:"try_xq",
        //   width: 200
        // },
        // {
        //   label:"客户账号",
        //   prop:"try_user",
        //   width: 100
        // },
        // {
        //   label:"密码",
        //   prop:"try_pasword",
        //   width: 100
        // },
        // {
        //   label:"备注",
        //   prop:"remarks",
        //   width: 150
        // },
        // {
        //   label:"客户姓名",
        //   slotName:"customer_name"
        // },
        {
          label: "指派操作",
          slotName: "zhipai",
        },
        {
          label: "签约操作",
          slotName: "signUp",
        },
        // {
        //   label:"客户信息详情",
        //   slotName:"info_detail"
        // },

        {
          label: "断约操作",
          slotName: "kill_contract",
        },
      ],
      // 主动跟新数据标记
      updateDataTag: false,
      resetPageNum: true, // 是否重置页面
      // 数据总条数
      totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名
      getTabData: {
        start: "",
        end: "",
        corporate_name: "", //公司名 默认空
        due_time_start: "", //到期开始时间
        due_time_end: "", // 到期结束时间
        brand_name: "", // 品牌名
        assign_id: "", // 店长
        assign_name_leader: "", // 组长
        properties: "", // 客户类型
        // contract_amount_state:'',// 合同金额区间开始
        // contract_amount_end:'',// 合同金额结束
        category: "", //类目
        sale_id: "",
        is_contract: "", // 试做状态
        is_Purchase: "",
        group: "", //运营一部：静微、聂敏、小平；二部：灶丽、夏娇
      }, //表格数据查询条件

      // 客户类型选项
      khlxOption: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "新签",
        },
        {
          value: 2,
          label: "续签",
        },
      ],

      // 沟通小记数据
      dialogVisible: false, //新建沟通小记对话框是否显示
      touchForm: {
        complaint: "",
        id: "", //客户编号
        user_name: "", //操作人
        contact_Records: "", //沟通小记
        contact_meth: "", //沟通方式
        remarks: "", //备注
        to_examine: "", //审核
        complaint: "", //投诉
      },
      touchRules: {
        //验证规则
        contact_Records: [
          { required: true, message: "请填写沟通小记", trigger: "change" },
        ],
        contact_meth: [
          { required: true, message: "请填写沟通方式", trigger: "change" },
        ],
        complaint: [],
        id: [],
        user_name: [],
        remarks: [],
        to_examine: [],
        complaint: [],
      },

      // 指派客户
      assignVisible: false, // 对话框显示
      assignForm: {
        // 指派客户表单
        id: "", //单条编号
        work_order_id: "", // 所属工单id
        assign_id: "", //被指派店长id
        name: "", //公司名称
        assign_id_leader: "", // 指派组长id
        assign_id_supervisor: "",
      },
      assignRules: {
        //验证规则
        id: [
          { required: true, message: "请填写客户编号", trigger: "change" },
          { type: "number", message: "客户编号必须为数字" },
        ],
        assign_id: [
          { required: true, message: "请选择店长", trigger: "change" },
        ],
      },
      department: utils.sessionGetStore("department"),
      jurisdiction: true, //权限 0:true    1,2:false

      zje: "", //总金额
      zsl: "", //总数量

      // 断约相关
      dy_reason: "", // 断约原因
      dyVisible: false, // 断约弹窗显示状态
      dyComtomer_id: "", // 断约客户id

      // 签约相关
      baseInfoVisible: false,
      contract_form: {},

      // 导出相关
      exportQX: true, // 导出数据权限 只有怒发、花花、技术部有权限
      exportDataAll: [],
      exportClickTag: false, // 点击导出标记
      // 详情查看
      detailConfig: {
        showSign: 0,
        contractProp: null,
      },
    };
  },
  watch: {},
  computed: {
    // 运营主管
    operateSuperOptions() {
      let leader = this.$store.state.leaderOptions.filter(
        (item) => item.value == "4",
      )[0].options;
      return [
        ...leader.filter((item) => item.post == "10"),
        { label: "龚蕾", value: "2" },
      ];
    },
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
    groupLeaderOptions() {
      return this.$store.getters.groupLeaderOptions;
    },
    operatePersonOptions() {
      return this.$store.getters.operatePersonOptions;
    },
    categoryOptions() {
      return this.$store.getters.categoryOptions;
    },
    operationDepartmentOptions() {
      return this.$store.state.commonOptions.operationDepartmentOptions;
    },
  },
  methods: {
    // 设置相关销售
    viewableHandle(val) {
      let paramObj = {
        customer_id: val.customer_id,
        viewable_person: val.viewable_person.join(","),
      };
      this.$tools.debounceFunc(() => {
        this.$api
          .updateViewablePerson(paramObj)
          .then((_) => {
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
          })
          .catch((error) => {
            console.log(error);
            this.$message.error("设置相关销售失败了");
          });
      }, 500);
    },
    // 导出功能相关
    exportClick() {
      // 点击导出标记更新， 子组件调用打开导出对话框
      // this.exportClickTag = !this.exportClickTag
      let paramObj = {
        id: this.userId,
        is_contract: 3,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api
        .tryOutExport(paramObj)
        .then((res) => {
          // console.log(res)
          if (res.data.code == 0) {
            window.location.href = res.data.data.url;
            loading.close();
          }
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          utils.notificationInfo("错误提示", "导出失败", "error");
        });
    },
    // 全部导出 暂不选择字段
    getApiParamsFunc(callBack) {
      // 若没有带条件查询，导出全部
      let paramObj = {
        id: this.userId,
        is_contract: 3, // 试做
      };
      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key]) {
          paramObj[key] = this.getTabData[key];
        }
      });
      // 执行回调
      callBack(paramObj);
    },

    setRPN(e) {
      this.resetPageNum = e;
    },
    // 断约改为结束试做，只做状态修改
    shutDownBtn(data) {
      this.$confirm(`是否确认对 ${data.corporate_name} 进行操作？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let paramObj = {
          id: data.id,
          is_contract: "4", // 3-进行中 4-试做结束
          up_user: this.userId, // 操作人
        };
        api
          .reviseCBInfo(paramObj)
          .then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              utils.notificationInfo("提示", "操作成功", "success");
            }
          })
          .catch((error) => {
            console.log(error);
            utils.notificationInfo("提示", "操作失败", "warning");
          });
      });
    },
    // 断约相关
    // 开启断约弹框
    openDYDialog(id) {
      this.dyComtomer_id = id;
      this.dyVisible = true;
    },
    // 客户断约状态操作 is_contract----- 1 断约   2 特批  0 签约
    insertcontract(data, contract, type) {
      if (this.dy_reason == "") {
        // 未填断约原因
        this.$message({
          type: "warning",
          message: "请填写断约原因",
        });
        return;
      } else {
        let paramObj = {
          id: this.dyComtomer_id,
          is_contract: "1",
          details: this.dy_reason, // 断约原因
        };

        api
          .breakContract(paramObj)
          .then((res) => {
            // console.log(res)
            if (res.data.code == 0) {
              utils.notificationInfo("提示", "设置断约状态成功", "success");
              // 更新
              this.updateDataTag = !this.updateDataTag;

              this.dyVisible = false;
              this.dy_reason = "";
              this.dyComtomer_id = "";
            }
          })
          .catch((error) => {
            console.log(error);
            utils.notificationInfo("提示", "设置断约状态失败", "warning");
          });
      }
    },

    // 签约相关
    // 打开签约对话框
    openContractDia(data) {
      // 初始化
      this.contract_form = {};
      // Object.keys(data).forEach(item => {
      //   this.contract_form[item] = data[item]
      // })
      let key = [
        // "customer_id", // 客户编号   20240909 梓龙说不传，保留试做信息，不传此参数时，签约会生成新的id
        "corporate_name", // 公司名
        "shop_url", // 旗舰店网址
        "id", // 当前信息id
        "main_products", // 主要产品
        "brand_name", // 品牌名
        "customer_file_id",
        "sale_id",
      ];
      key.forEach((k) => {
        this.contract_form[k] = data[k];
      });

      // 导入指派人员信息
      this.contract_form.assignInfo = {
        assign_id: data.assign_id,
        assign_id_leader: data.assign_id_leader,
        assign_id_supervisor: data.assign_id_supervisor,
      };
      this.baseInfoVisible = true;
    },
    // 提交签约后回调
    subComplete() {
      this.baseInfoVisible = false;
      utils.notificationInfo("提示", "签约申请已提交", "success");
      // 更新
      this.updateDataTag = !this.updateDataTag;
      this.resetPageNum = false;
    },

    // 客户指派相关
    //  打开客户指派对话框
    openAssignDia(data) {
      Object.keys(this.assignForm).forEach((key) => {
        this.assignForm[key] = "";
      });
      // 客户编号自动填入
      // this.assignForm.id = Number(data.id)
      this.assignForm.id = data.customer_id;

      this.assignForm.work_order_id = data.work_order_id;

      this.assignForm.name = data.corporate_name;

      this.assignVisible = true;

      if (
        data.assign_id_leader != "" &&
        data.assign_id_leader != null &&
        data.assign_id_leader != "null"
      ) {
        // 组长
        this.assignForm.assign_id_leader = data.assign_id_leader;
      }
      if (
        data.assign_id != "" &&
        data.assign_id != null &&
        data.assign_id != "null"
      ) {
        this.assignForm.assign_id = data.assign_id;
      }
      if (data.assign_id_supervisor) {
        this.assignForm.assign_id_supervisor = data.assign_id_supervisor;
      }
    },
    //  客户指派操作
    assignHandle(fN) {
      // 表单验证
      this.$refs[fN].validate((valid) => {
        if (valid) {
          this.assignVisible = false;
          let paramObj = this.assignForm;
          paramObj.up_user = this.userId;
          paramObj.state = "1"; //指派状态 1 已指派

          api
            .customerAssign(paramObj)
            .then((res) => {
              // console.log('小记返回值',res)
              utils.notificationInfo("提示", "指派成功", "success");
              // 主动更新数据标记---更新
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              // 重置表单
              this.$refs[fN].resetFields();
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "指派失败", "error");
            });
        } else {
          // console.log('error submit!!');
          utils.notificationInfo("提示", "操作失败", "error");
          return false;
        }
      });
    },
    // 关闭对话框前触发
    assignClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //
    //  新建小记对话框,
    //
    // 在点击对话框之外时，会弹出此对话框
    addClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 开启对话框
    openDialog(scope, view) {
      // console.log("沟通小记",scope,this.userName)
      this.dialogVisible = view;
      this.touchForm.name = scope.corporate_name; //公司名
      this.touchForm.id = scope.id;
      this.touchForm.user_name = this.userName;
    },
    //确认新建
    addTouchInfo(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          let paramObj = {
            e_id: this.touchForm.id,
            user_id: this.userId,
            communicate_record: this.touchForm.contact_Records,
            communication_mode: this.touchForm.contact_meth,
            remarks: this.touchForm.remarks,
            to_examine: this.touchForm.to_examine,
            complaint: this.touchForm.complaint,
          };
          api
            .addTouchInfo(paramObj)
            .then((res) => {
              // console.log('小记返回值',res)
              utils.notificationInfo("提示", "新建成功", "success");
              // 主动更新数据标记---更新
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              // 重置表单
              this.$refs[formName].resetFields();
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "新建失败", "error");
            });
        } else {
          // console.log('error submit!!');
          utils.notificationInfo("提示", "新建失败", "error");
          return false;
        }
      });
    },

    //  添加波罗蜜
    // 点击 波罗蜜的修改图标
    remarkEditClick(index) {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].boluomiVisible = false;
      }
      this.dataList[index].boluomiVisible = true;
    },
    // 修改波罗蜜
    remarkEditConfirm(row, index) {
      // console.log(row)
      let paramObj = {
        id: row.id,
        boluomi: row.boluomi,
      };

      // boluomi 输入为空时，传递过去只能是 0
      if (row.boluomi == "") {
        paramObj.boluomi = 0;
      }
      // api
      api
        .reviseBoluomi(paramObj)
        .then((res) => {
          // console.log(res)
          this.dataList[index].boluomiVisible = false;
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 提交反馈
    subFeedBack(data) {
      let paramObj = {
        feedback_info: data.feedback_info,
        id: data.id,
      };
      api
        .reviseCBInfo(paramObj)
        .then((res) => {
          if (res.data.code == 0) {
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //
    //
    //跳转详情页
    //
    // 弃用
    goToDetail(row) {
      if (this.getTabData.is_Purchase) {
        return;
      }
      // console.log('detail',row)
      let r = this.$router.resolve({
        path: "/index/customerManage/customerInfoDetail",
        query: {
          orderId: row.customer_id,
          corporate_name: row.corporate_name, //公司名
          sign: 2, // 试做客户标识标识
        },
      });
      window.open(r.href, "_blank");
    },
    handleDetail(row) {
      // 购买人员 只读
      if (this.getTabData.is_Purchase) {
        return;
      }
      this.detailConfig.showSign++;
      this.detailConfig.contractProp = {
        sign: 2, // 进入详情类型标识  // 试做
        ...row,
      };
    },

    //带条件查询，查询按钮事件
    searchBtn(e) {
      if (e == "contact" && this.valueDate && this.valueDate.length > 0) {
        this.getTabData.start = this.valueDate[0];
        this.getTabData.end = moment(this.valueDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.start = "";
        this.getTabData.end = "";
      }
      if (e == "due" && this.dqsjDate) {
        this.getTabData.due_time_start = this.dqsjDate[0];
        this.getTabData.due_time_end = moment(this.dqsjDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.due_time_start = "";
        this.getTabData.due_time_end = "";
      }
      utils.debounceFunc(() => {
        utils.sessionSetStore("tryCustomSearch", this.getTabData);
        this.updateDataTag = !this.updateDataTag;
      });
    },

    //重置查询
    resetSearch() {
      this.valueDate = [];
      this.dqsjDate = [];
      Object.keys(this.getTabData).forEach((key) => {
        this.getTabData[key] = "";
      });
      this.getTabData.id = this.userId;
      utils.sessionRemoveStore("tryCustomSearch");
      this.updateDataTag = !this.updateDataTag;
    },

    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {};

      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key]) {
          paramObj[key] = this.getTabData[key];
        }
        // else {
        //   if(key == 'is_contract') {
        //     paramObj.is_contract = 3
        //   }
        // }
      });
      paramObj.is_contract = 3;
      return {
        apiName: "getCustomersData",
        paramObj: paramObj,
        success: function (response, callBack) {
          this.zje = response.data.data.contract_amount_Count;
          this.zsl = response.data.data.totalCount;

          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];
            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });
            // 相关销售姓名转换
            obj.viewable_name = [];
            if (obj.viewable_person) {
              obj.viewable_person = obj.viewable_person.split(","); // 转为数组
              obj.viewable_person.forEach((userID) => {
                obj.viewable_name.push(this.$tools.conversionName(userID));
              });
            }

            obj.boluomiVisible = false; // 添加波罗蜜的小框默认不显示

            arr.push(obj);
          }
          // console.log("公司名",this.cnOption)
          // console.log(records)
          // 数据列表---更新
          this.dataList = arr;
          // console.log('工单列表',this.dataList)
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数
          // console.log("审核列表",response)

          // records.forEach(items => {
          //   let cnObj = {
          //     value:items.corporate_name,
          //     label:items.corporate_name
          //   }
          //   this.cnOption.push(cnObj)
          // })

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function (error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");
    this.getTabData.id = this.userId;

    // 获取权限
    let jur = utils.sessionGetStore("jurisdiction");
    this.jurisdiction =
      jur == "0" &&
      (this.userId == 1 || this.userId == 2 || this.department == "7")
        ? true
        : false;

    // 获取存在本地的查询条件
    let customSearch = JSON.parse(utils.sessionGetStore("tryCustomSearch"));
    // console.log(customSearch)
    if (customSearch) {
      this.getTabData = customSearch;
      this.valueDate = [this.getTabData.start, this.getTabData.end];
      this.dqsjDate = [
        this.getTabData.due_time_start,
        this.getTabData.due_time_end,
      ];
    }

    // window.addEventListener('setTryStorage',()=> {
    //     this.currentPage = Number(utils.sessionGetStore('tryItOutList'))
    // })

    // 导出功能权限
    if (this.department == "6" || this.department == "7" || this.userId == 2) {
      // 关闭文颖13和明锋53的导出权限
      this.exportQX = true;

      // 最高权限有波罗蜜
      this.exportDataAll.push({
        chinese: "波罗蜜",
        english: "boluomi",
      });
    } else {
      this.exportQX = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    margin-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }

  .totalAmount {
    position: absolute;
    width: 300px;
    // background: red;
    bottom: 25px;
    right: 20px;

    > p {
      font-size: 16px;
      font-weight: 500;
      > span {
        font-size: 16px;
        color: #409eff;
      }
    }
  }
}

.demo-ruleForm {
  > h3 {
    font-size: 16px;
    text-align: center;
    padding: 20px 0;
    color: #409eff;
    letter-spacing: 1px;
  }
  > div {
    padding: 20px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    .formItems {
      width: 30%;
    }
  }
}
</style>
